"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDirective = isDirective;
const real_type_of_1 = require("../real-type-of");
function isDirective(obj) {
    if (!(0, real_type_of_1.isObject)(obj)) {
        return false;
    }
    const keys = Object.keys(obj);
    const hasDirectivePrefix = keys.some((key) => key.startsWith('@'));
    if (!hasDirectivePrefix) {
        return false;
    }
    const otherKeys = keys.filter((key) => !key.startsWith('@') && key !== '_metadata');
    if (otherKeys.length === 0) {
        return true;
    }
    return false;
}
//# sourceMappingURL=is-directive.js.map